/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CountyContext from '../../contexts/CountyContext';
import StoryContext from '../../contexts/StoryContext';
import { composeWhereClause } from '../../modules/data';
import { rdsTabulate } from '../../modules/rds';
import states, { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';
import HorizontalBarChart from '../HorizontalBarChart';

function AccessBySettingType({ height = 300 }) {
  const { stateCode } = useParams();
  const [, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const { countyCode, county } = useContext(CountyContext);
  const { primaryColor, secondaryColor } = useContext(StoryContext);

  useEffect(() => {
    // const server = new RdsServer(process.env.REACT_APP_RDS_SERVER);

    async function getData() {
      // Instantiate a catalog that exists on the server
      // const catalog = new RdsCatalog(server, 'ccdc');
      // Instantiate a data product that exists on the catalog
      // const dataProduct = new RdsDataProduct(catalog, 'county_licensed_capacity');
      let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} AND capacity_type=LIC`;

      whereClause += composeWhereClause({});

      if (countyCode) {
        whereClause += ` AND county_fips=${countyCode}`;
      }

      rdsTabulate('ccdc', 'county_licensed_capacity', {
        dims: 'state_fips,setting_type',
        measure: 'capacity:SUM(capacity)',
        where: whereClause,
        format: 'amcharts',
        inject: true,
      })
        .then((result) => {
          const d = result.parsedBody.dataProvider;
          const total = d.reduce((a, v) => (a + Number.parseInt(v.capacity, 10)), 0);
          const payload = d.map((v) => Object.assign(v, { percent: ((v.capacity / total) * 100) }));
          setData(payload);
        })
        .catch((rdsError) => {
          setError(rdsError);
        })
        .finally(() => {
          setReady(true);
        });
      // setData([
      //   { groupKey: 'Infants and Toddlers', 'For married-couple families': random(30) / 100, 'For single-parent families': random(30) / 100 },
      //   { groupKey: 'Preschoolers', 'For married-couple families': random(30) / 100, 'For single-parent families': random(30) / 100 },
      // ]);
    }
    if (stateCode && states[stateCode.toUpperCase()]) {
      // fetch actual average price data
      getData();
    }
  }, [stateCode, countyCode]);

  const keys = ['capacity'];
  const groupKey = 'setting_type';

  let title = 'Setting Type';
  if (county) {
    title += ` - ${county} County`;
  }

  const tooltipFormatter = function tooltipFormatter(payload) {
    return `${toFormattedNumber(payload.payload.percent)}% are in ${payload.payload.setting_type.toLowerCase()}.`;
  };

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <HorizontalBarChart
        height={height}
        data={data}
        tooltipFormatter={tooltipFormatter}
        valueFormatter={toFormattedNumber}
        keys={keys}
        groupKey={groupKey}
        title={title}
        colors={[primaryColor, secondaryColor]}
        showYTick
      />
    </>
  );
}

export default AccessBySettingType;
